let Translations = {
    en: {
        SessionTimeout: {
            title: 'Your Session is about to expire!',
            message: 'Your session is about to expire.',
            logoutButton: 'Logout',
            keepAliveButton: 'Stay Connected',
            sessionExpired: 'Your session might be expired.'
        },
        Help: {
            text: 'Need help? Click here for more information'
        }
    },
    es: {
        SessionTimeout: {
            title: 'Tu sesión está a punto de expirar!',
            message: 'Tu sesión está a punto de expirar.',
            logoutButton: 'Cerrar sesión',
            keepAliveButton: 'Seguir conectado',
            sessionExpired: 'Puede que tu sesión haya expirado.'
        },
        Help: {
            text: '¿Necesitas ayuda? Más info.'
        }
    },
    et: {
        SessionTimeout: {
            title: 'Teie sessioon hakkab aeguma!',
            message: 'Teie sessioon hakkab aeguma.',
            logoutButton: 'Logi välja',
            keepAliveButton: 'Jätka sessiooni',
            sessionExpired: 'Teie sessioon võib olla aegunud.'
        },
        Help: {
            text: 'Vajad abi? Vajuta siia, et saada rohkem infot.'
        }
    },
    it: {
        SessionTimeout: {
            title: 'La tua sessione sta per scadere!',
            message: 'La tua sessione sta per scadere',
            logoutButton: 'Logout',
            keepAliveButton: 'Rimani connesso',
            sessionExpired: 'La tua sessione potrebbe essere scaduta'
        },
        Help: {
            text: 'Hai bisogno di aiuto? Clicca qui"'
        }
    },
    fr: {
        SessionTimeout: {
            title: 'Votre session est sur le point d\'expirer !',
            message: 'Votre session est sur le point d\'expirer.',
            logoutButton: 'Déconnexion',
            keepAliveButton: 'Rester connecté',
            sessionExpired: 'Votre session a expiré.'
        },
        Help: {
            text: 'Besoin d\'aide? Cliquez ici pour plus d\'informations'
        }
    }
};

export default Translations;
